import { Link, NavLink, Outlet } from 'react-router-dom';
import { TabStrip } from '../../components/fs';
import { useSiteViewer } from './SiteLayout';

/**
 * The community's shared header and tab row. Reading is open to everyone;
 * the line under the title tells strangers how to join the conversation.
 *
 * R13 (ABC6-06): "Community" over the standard 38px tab row (`fs-tabs`, which
 * scrolls sideways on a phone), then the page.
 */
export default function CommunityLayout() {
  const viewer = useSiteViewer();
  return (
    <div className="site-page community-page" data-frame="column">
      <div className="comm-head">
        <h1 className="site-h1">Community</h1>
        <p className="comm-sub">
          Help, ideas, and what's new. Questions are answered by Form-Magic staff{' '}
          <span className="fs-pill identity">Form-Magic team</span> and by other customers. Anyone can
          read; posting takes a{' '}
          {viewer ? 'Form-Magic login — you are signed in.' : <Link to="/pricing">Form-Magic account</Link>}
        </p>
      </div>
      <TabStrip as="nav" className="fs-tabs comm-tabs" aria-label="Community">
        <NavLink to="/community" end>Forum</NavLink>
        <NavLink to="/community/feature-requests">Feature requests</NavLink>
        <NavLink to="/community/releases">Releases</NavLink>
      </TabStrip>
      <Outlet />
    </div>
  );
}
